// extracted by mini-css-extract-plugin
module.exports = {"addButtonsContainer":"input-names-container_addButtonsContainer__uaLRZ","addButtonContainer":"input-names-container_addButtonContainer__ZvIE3"};